module.exports = __webpack_public_path__ + "static/card6-089393ebc661abda5e7ecefff293d102.png";